import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuth, useSidebar } from '../app/providers';
import { ErrorBoundary, SkipLink } from '../shared/components';

import Header from './Header';
import Sidebar from './Sidebar';


const AdminLayout: React.FC = () => {
    const { user, isLoading } = useAuth();
    const { isCollapsed } = useSidebar();
    const navigate = useNavigate();

    // Auth check
    useEffect(() => {
        if (!isLoading && !user) {
            navigate('/admin-login');
        }
    }, [user, isLoading, navigate]);

    // Show loading state while checking auth
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
                    <p className="text-sm text-slate-500">Loading...</p>
                </div>
            </div>
        );
    }

    // Don't render if not authenticated
    if (!user) {
        return null;
    }

    return (
        <div className="min-h-screen bg-slate-50">
            {/* Skip Link for accessibility */}
            <SkipLink targetId="main-content" />

            {/* Sidebar */}
            <Sidebar />

            {/* Main content area */}
            <div
                className={`
          transition-all duration-300
          ${isCollapsed ? 'lg:pl-[72px]' : 'lg:pl-64'}
        `}
            >
                {/* Header */}
                <Header />

                {/* Page content */}
                <main id="main-content" className="pt-16 min-h-screen" role="main">
                    <div className="p-4 lg:p-6">
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
